import { CustomerCustomComponents } from '../customerCustomComponents'

/**
 * This file defines the components and styles that are specific to this customer.
 * These custom components are based on parent components, which are used by default.
 */

export const defaultComponents: CustomerCustomComponents = {}
